var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8.898,
  height: 16,
  viewBox: "0 0 8.898 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_366",
  "data-name": "Path 366",
  d: "M395.377,616.964c-.032-.359,0-6.548,0-6.548h-2.029V607.37h2.029s-.074.247,0-1.838.464-2.477.991-3.039a4.558,4.558,0,0,1,2.118-1.1,9.569,9.569,0,0,1,2.387-.144,9.344,9.344,0,0,1,1.373.3v2.684a12.875,12.875,0,0,0-2.3,0c-.727.13-.9.787-1,1.292a10.837,10.837,0,0,0,0,1.838h3.121l-.689,3.046h-2.645v6.795h-2.842S395.41,617.323,395.377,616.964Z",
  transform: "translate(-393.349 -601.227)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/facebook.72f9c16f.svg";
export { SvgComponent as ReactComponent };